module.exports = __webpack_public_path__ + "static/media/delete-icon.2560c4b3.svg";